export enum OrganisationLocalStorageKeys {
  orgId = 'ORG_ID',
}

export enum LocalStorageKeys {
  token = 'video_auth_token',
  userId = 'video_auth_user_id',
}
